const NETWORK_MESSAGE = 'could not reach the server';
const GENERIC_MESSAGE = 'the server rejected the request';
const SERVER_CODE = /^[A-Z][A-Z0-9_]+$/;

export class ApiError extends Error {
  constructor(message, { status = 0, code, body, cause } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.body = body;
    this.cause = cause;
  }
}

const readMessage = (body) => {
  if (typeof body === 'string') {
    return body.trimStart().startsWith('<') ? undefined : body;
  }

  const message = body?.message ?? body?.error;

  if (Array.isArray(message)) {
    return message.join('; ');
  }

  return typeof message === 'string' ? message : undefined;
};

const readCode = (body, message) => {
  if (typeof body?.code === 'string') {
    return body.code;
  }

  return message && SERVER_CODE.test(message) ? message : undefined;
};

export const toApiError = (error) => {
  if (error instanceof ApiError) {
    return error;
  }

  const response = error?.response;

  if (!response) {
    return new ApiError(NETWORK_MESSAGE, {
      code: 'NETWORK_ERROR',
      cause: error,
    });
  }

  const body = response.data;
  const message = readMessage(body)?.trim();

  return new ApiError(message || GENERIC_MESSAGE, {
    status: response.status,
    code: readCode(body, message),
    body,
    cause: error,
  });
};
